// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".X4oHd {\n  position: relative;\n  height: 24px;\n  border-width: 2px;\n  background-color: var(--color-gray);\n  border: var(--color-gray);\n}\n\n.VFnFb {\n  line-height: 24px;\n  font-weight: bold;\n  color: var(--color-white);\n}\n\n._55C6l {\n  width: 196px;\n  text-align: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": "X4oHd",
	"label": "VFnFb",
	"tooltip": "_55C6l"
};
export default ___CSS_LOADER_EXPORT___;
